export default __webpack_public_path__ + "s5.png";